// TODO: #649 Try to avoid using const in switch-case statement in order not to unnecessary pollute namespace

import { combineReducers } from 'redux';
import { types } from '@actions/admin';

const initialState = {
  users: {
    data: [],
    loading: false,
    failed: false,
  },
  createUser: {
    loading: false,
    failed: false,
  },
  createUserForm: {
    username: null,
    email: null,
    password: null,
  },
  deleteUser: {
    loading: false,
    failed: false,
  },
  editUser: {
    loading: false,
    failed: false,
  },
  editUserForm: {
    userId: null,
    selectedPermission: null,
  },
  settings: {},
};

export default combineReducers({
  users: (state = initialState.users, action = {}) => {
    switch (action.type) {
      case types.LOAD_USERS.REQUEST:
        return { ...state, loading: true };
      case types.LOAD_USERS.RESPONSE:
        const { payload, error } = action;
        return {
          ...state,
          data: payload,
          loading: false,
          failed: !!error,
        };
      default: {
        return state;
      }
    }
  },
  createUser: (state = initialState.createUser, action = {}) => {
    switch (action.type) {
      case types.CREATE_USER.REQUEST:
        return { ...state, loading: true };
      case types.CREATE_USER.RESPONSE:
        const { error } = action;
        return {
          ...state,
          loading: false,
          failed: !!error,
        };
      default: {
        return state;
      }
    }
  },
  createUserForm: (state = initialState.createUserForm, action = {}) => {
    switch (action.type) {
      case types.CREATE_USER.RESPONSE:
        return !action.error ? initialState.createUserForm : state;
      case types.CREATE_USER.FIELD:
        return {
          ...state,
          [action.payload.field]: action.payload.value,
        };
      default: {
        return state;
      }
    }
  },
  deleteUser: (state = initialState.deleteUser, action = {}) => {
    switch (action.type) {
      case types.DELETE_USER.REQUEST:
        return { ...state, loading: true };
      case types.DELETE_USER.RESPONSE:
        const { error } = action;
        return {
          ...state,
          loading: false,
          failed: !!error,
        };
      default: {
        return state;
      }
    }
  },
  editUser: (state = initialState.editUser, action = {}) => {
    switch (action.type) {
      case types.EDIT_USER.REQUEST:
        return { ...state, loading: true };
      case types.EDIT_USER.RESPONSE:
        const { error } = action;
        return {
          ...state,
          loading: false,
          failed: !!error,
        };
      default: {
        return state;
      }
    }
  },
  editUserForm: (state = initialState.editUserForm, action = {}) => {
    switch (action.type) {
      case types.EDIT_USER.FIELD:
        return { ...state, selectedPermission: action.payload };
      case types.EDIT_USER.SHOW:
        const { userId, permission } = action.payload;
        return { ...state, userId, selectedPermission: permission };
      case types.EDIT_USER.HIDE:
        return initialState.editUserForm;
      default:
        return state;
    }
  },
  settings: (state = initialState.settings, action = {}) => {
    switch (action.type) {
      case types.UPDATE_ADMIN_SETTINGS:
        return { ...state, ...action.settings };
      default: {
        return state;
      }
    }
  },
});



// WEBPACK FOOTER //
// ./redux/reducers/admin.js